export const data = {
	heading: '2021 год — год больших достижений',
	content:
		'В 2022 году мы привлекли 2 млн евро от известных бизнес-ангелов и текущих акционеров в ходе pre-series-А раунда. Так, благодаря команде и нашим технологиям, мы смогли завоевать доверие крупных инвесторов. Их деньги мы направили на развитие цифровых продуктов и масштабирование команды.',
	card: {
		heading:
			'Открыли доступ к личному кабинету кредитора — в нём есть всё для быстрого запуска залогового кредитования в банке и любой другой финансовой организации.',
		content: [
			'Если кредитору нужно запустить нецелевую ипотеку с нуля, он просто регистрируется в личном кабинете, подписывает документы — и готово. Остальное берём на себя мы и наши технологии.',
		],
		link: {
			content: 'Узнать о платформе',
			href: 'https://creditclub.tech',
		},
	},
}
